import Vue from 'vue';
import Router from 'vue-router';
import HomePage from '../components/HomePage.vue'; // Import the HomePage component
import ContactPage from '../components/ContactPage.vue'; 
import ServicesPage from '../components/ServicesPage.vue'; 
import AboutMePage from '../components/AboutMePage.vue'; 


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
    },
    {
        path: '/services',
        name: 'services',
        component: ServicesPage,
      },
    {
      path: '/contact',
      name: 'contact',
      component: ContactPage,
    },
    {
      path: '/about',
      name: 'about',
      component: AboutMePage,
    },
  ],
});
